import { readOperationControls } from 'flare-chat-core/contracts/workflow/operations';

const LABELS = new Map([
  ['workflow.node.retry', '重试'],
  ['workflow.node.accept', '确认'],
]);

const objectValue = (value) => (
  value && typeof value === 'object' && !Array.isArray(value) ? value : {}
);
const text = (value = '') => String(value ?? '').trim();

export const workflowOperationActionKey = (action = {}) => text(action.action_key);

export const buildWorkflowOperationActions = (item = {}, { pendingActionKey = '', adapterAvailable = true } = {}) => {
  if (item?.type !== 'thinking') return [];
  return readOperationControls(item.workflowProjection ?? item.workflow_projection).map((descriptor) => ({
    ...descriptor,
    label: LABELS.get(descriptor.operation_type),
    run_id: descriptor.target.run_id,
    disabled: !descriptor.available || !adapterAvailable || Boolean(pendingActionKey),
    pending: pendingActionKey === descriptor.action_key,
  }));
};

export const attachWorkflowOperationActions = (items = [], options = {}) => (
  (Array.isArray(items) ? items : []).map((item) => {
    if (item?.type !== 'thinking') return item;
    return { ...item, workflowOperationActions: buildWorkflowOperationActions(item, options) };
  })
);

export function buildWorkflowOperationRequest(action = {}, { now = () => Date.now() } = {}) {
  const source = objectValue(action);
  const operationType = text(source.operation_type);
  const target = { ...objectValue(source.target) };
  const targetKey = text(target.node_id || target.step_id || target.run_id || 'target').replace(/[^a-zA-Z0-9_-]+/g, '_');
  const timestamp = text(now());
  return {
    operation_id: ['runtime-operation', operationType.replace(/[^a-zA-Z0-9_-]+/g, '_'), targetKey, timestamp]
      .filter(Boolean)
      .join(':'),
    operation_type: operationType,
    target,
    requested_by: 'ui',
    input_payload: {},
  };
}
